var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('TopBar'),_c('div',{staticClass:"bg"},[_c('router-view')],1),(_vm.isRouterAlive)?_c('Footer',{attrs:{"v":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }